const isMobile = () => typeof window !== "undefined" && window.innerWidth < 768;

export const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: isMobile() ? 0 : 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-40px" },
  transition: { duration: 0.6, delay, ease: "easeOut" },
});

export const revealNow = (delay = 0) => ({
  initial: { opacity: 0, y: isMobile() ? 0 : 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay, ease: "easeOut" },
});
